import axios from "axios";

export const clientAPI = axios.create({
    baseURL: `${process.env.NEXT_PUBLIC_API!}`,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
    },
})

clientAPI.interceptors.request.use((config) => {
  if (typeof window !== "undefined") {
    const jwt = localStorage.getItem('volatile-auth');
    if (jwt) {
      config.headers = config.headers || {};
      config.headers['Authorization'] = `Bearer ${jwt.replace(/^"(.*)"$/, '$1')}`;
    }
  }
  return config;
});
